/*
    Action:     Draws the league dropdown. The component has its own store and own set of logic
                so is an independent component to its parent
    Orginator:  ben.hobden@espn.com
*/

var React               = require('react');
var Router              = require('react-router');
var Link                = require('react-router').Link;
var classNames          = require('classnames');
var StoreMixin          = require('fluxible/addons/FluxibleMixin');
var DropDown            = require('../common/dropdown.jsx');
var loadLeagues         = require('../../actions/loadLeagues');
var Path                = require('../../helpers/utils/path.js');

var Tabs = React.createClass({

    displayName: 'LeagueList',

    mixins: [StoreMixin],

    statics: {
        storeListeners: ['LeagueStore']
    },

    getInitialState: function () {
        return this.getStateFromStores();
    },

    getStateFromStores: function () {
        var oLeaguesStore = this.props.context.getStore('LeagueStore');
        return oLeaguesStore.getLeagues();
    },

    onChange: function () {
        this.setState(this.getStateFromStores());
    },

    componentWillMount: function () {
        if(!this.props.preventLeagueAction){
            this.props.context.executeAction(loadLeagues,{sport:this.props.sport});
        }
    },

    render: function () {

        var sRoot       = this.props.root || '';
        var sPage       = this.props.page || '';
        var sSport      = this.props.sport || '';
        var sLeague     = this.props.league || '';
        var sLabel      = this.props.label || '';

        var aLeagues    = this.state.leagues || [];
        var sBaseUrl    = '/' + sRoot + '/' + sPage;
        var aItems      = [];

        var iLen = aLeagues && aLeagues.length;
        for (var i = 0; i < iLen; ++i) {
            var oLeague = aLeagues[i];

            if (sPage === 'standings' || sPage === 'table') {
                if (typeof oLeague.season === "undefined" || typeof oLeague.season.type === "undefined" || oLeague.season.type.hasStandings === false) {
                    //console.log(oLeague.season.type.hasStandings);
                    continue;
                }
            }

            var sCurrLeague = oLeague.midsizeName.toLowerCase();
            if (sLeague === sCurrLeague) {
                sLabel = oLeague.name;
            }

            var oParams = {
                'league': sCurrLeague
            };

            //oParams['season'] = oSeason.year;
            var sURL = (typeof this.props.urlFormatter == 'function') ? this.props.urlFormatter(sBaseUrl, oParams) : Path.encode(sBaseUrl, oParams, {});

            var oTmpLink = {
                name: oLeague.name,
                url: sURL,
                trackVar: sLeague + ":" + sPage + ":filter:league",
                reactURL: true
            };
            aItems.push(oTmpLink);
        }

        var oDDConfig = {
            name: sLabel,
            items: aItems
        };
        
        if(this.props.id){
            oDDConfig.id = this.props.id;
        }

        return (
            <DropDown {...oDDConfig}/>
        );
    }

});

module.exports = Tabs;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/Leaguelist.jsx
 **/